function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    /* prettier-ignore */\n    ", " \n    padding: ", "px;\n    ", "\n    ", "\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      padding-top: ", "px;\n      padding-bottom: ", "px;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n      padding-top: ", "px;\n      padding-bottom: ", "px;\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import SPACING, { BASE_SPACING, BASE_STYLES } from './constants';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { withDynamicTag } from '@doordash/utilities';

var getSquishedPadding = function getSquishedPadding(props) {
  if (props.isSquished) {
    return css(_templateObject(), props.size / 2, props.size / 2);
  }

  return null;
};

var getStretchedPadding = function getStretchedPadding(props) {
  if (props.isStretched) {
    return css(_templateObject2(), props.size * 2, props.size * 2);
  }

  return null;
};

var Inset = withDynamicTag(styled.div(_templateObject3(), BASE_STYLES, function (props) {
  return props.size;
}, getSquishedPadding, getStretchedPadding));
Inset.Sizes = SPACING;
Inset.propTypes = {
  size: PropTypes.oneOf(Object.values(Inset.Sizes)),
  isSquished: PropTypes.bool,
  isStretched: PropTypes.bool
};
Inset.defaultProps = {
  size: BASE_SPACING,
  isSquished: false,
  isStretched: false
};
export default Inset;